"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 16px;\n  height: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  width: 16px;\n  height: 8px;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _buoyTheme2 = _interopRequireDefault(_buoyTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "src__Container",
  componentId: "sc-13ziw93-0"
})(_templateObject);

var Arrow = function Arrow(_ref) {
  var color = _ref.color;
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "8",
        viewBox: "0 0 18 10"
      },
      _react2.default.createElement("path", {
        fill: "none",
        fillRule: "evenodd",
        stroke: _buoyTheme2.default.colors[color],
        d: "M0 1l9.052 8L18 1",
        strokeWidth: "1"
      })
    )
  );
};

Arrow.defaultProps = {
  color: "primary"
};

exports.default = (0, _styledComponents.withTheme)(Arrow);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-arrow/dist/index.js
// module id = 145
// module chunks = 168707334958949